<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h5>Орієнтовна вартість швидкодіючої ПКРП з дроселями 189 Гц, євро за кВАр</h5>
                <div class="flex" style="gap: 20px;">
                    <input v-model="default_value_value" class="nominal_select">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="updateDefaultDinupdateDefaultDin(1, default_value_value, 'calculator_default_value')"
                    >
                        Зберегти
                    </button>
                </div>
                <br>
                <ProgressBar mode="indeterminate" style="height: .5em" v-if="progress" />
            </div>
            <div class="card">
                <h5>Керування контактом для зворотнього зв'язку</h5>
                <div class="flex" style="gap: 20px;">
                    <input v-model="calculator_phone_number_value" class="nominal_select">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="updateDefaultDinupdateDefaultDin(1, calculator_phone_number_value, 'calculator_phone_number_value')"
                    >
                        Зберегти
                    </button>
                </div>
                <label style="display: block; margin-top:10px;">
                    <input type="checkbox" v-model="calculator_phone_number_view" @change.prevent="updateDefaultDinupdateDefaultDin(1, calculator_phone_number_view, 'calculator_phone_number_view')">
                    Відображати в сервісі
                </label>
                <br>
                <ProgressBar mode="indeterminate" style="height: .5em" v-if="progress" />
            </div>
            <div class="card">
                <h5>Керування віджетом онлайн-чату</h5>
                <div class="flex" style="gap: 20px; align-items: end;">
                    <textarea v-model="widget" rows="10" cols="90"></textarea>
                    <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="updateDefaultDinupdateDefaultDin(1, widget, 'widget')"
                    >
                        Зберегти
                    </button>
                </div>
                <label style="display: block; margin-top:10px;">
                    <input type="checkbox" v-model="widget_view" @change.prevent="updateDefaultDinupdateDefaultDin(1, widget_view, 'widget_view')">
                    Відображати в сервісі
                </label>
                <br>
                <ProgressBar mode="indeterminate" style="height: .5em" v-if="progress" />
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import moment from "moment";
import Input from '../Jetstream/Input.vue';
import axios from "axios";
import Label from '../Jetstream/Label.vue';

export default {
    layout: AppLayout,
    props: {
        default_value: {
            type: Number,
            required: false,
        },
        phone_number: {
            required: false,
        },
        phone_number_view: {
            required: false,
        },
        widget_value: {
            required: false,
        },
        widget_value_view: {
            required: false,
        },
    },
    data() {
        return {
            moment: moment,
            progress: false,
            progressKrm: false,
            progressCatalog: false,
            progressCatalogName: false,
            default_value_value: this.default_value,
            calculator_phone_number_value: this.phone_number,
            calculator_phone_number_view: this.phone_number_view,
            widget: this.widget_value,
            widget_view: this.widget_value_view,
        }
    },
    components: {
        ProgressBar,
        "p-fileupload": FileUpload,
        "p-toast": Toast,
        Input,
        Label
    },
    methods: {
        updateDefaultDinupdateDefaultDin(id, text, type) {
            axios.post(this.route('api.vector.calculator_update_default'), {id: id, comment: text, type: type})
            .then((result) => {
                this.$toast.add({severity: 'info', summary: 'Success', detail: 'Значення збережено!', life: 3000});
            }).catch((error) => {
                console.log(error);
            })
        }
    }
};
</script>
